export default __webpack_public_path__ + "static/media/Alert.3f2d8648.svg";